// ============================================================
// ✅ ParametragePage.jsx - Page principale
// ============================================================

import React, { useState } from 'react';
import { Settings } from 'lucide-react';
import LiaisonsTab from './LiaisonsTab';
import ReglesTab from './ReglesTab';

export default function ParametragePage() {
  const [activeTab, setActiveTab] = useState('liaisons');

  return (
    <div className="p-3 md:p-5 bg-gray-50 min-h-screen">
      
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800 flex items-center gap-2">
          <Settings size={22} /> Paramétrage des règles
        </h2>
        <p className="text-xs text-gray-400">
          Priorité : 👤 Employé &gt; 🏢 Société &gt; 🌍 National
        </p>
      </div>

      <div className="flex gap-2 mb-4">
        {['liaisons', 'regles'].map(tab => (
          <button key={tab} onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition ${
              activeTab === tab ? 'bg-emerald-500 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}>
            {tab === 'liaisons' ? '🔗 Liaisons' : '📜 Règles'}
          </button>
        ))}
      </div>

      {activeTab === 'liaisons' ? <LiaisonsTab /> : <ReglesTab />}
    </div>
  );
}